module.exports = function() {
  return new Worker(__webpack_public_path__ + "28529b43d0722a4350fc.worker.js");
};